import React from 'react'
import { useTranslation } from 'react-i18next'

const AboutUsCards = () => {
    const { t } = useTranslation();

    return (
        <div className='about-us-cards-content'>
            <div className="container">
                <h3 className='text-center'>{t('Yatırımda Güven ve Başarı İçin Doğru Adres')}</h3>
                <div className="row mt-5">
                    <div className="col-xl-3 col-lg-6">
                        <div className="about-us-card shadow-sm mb-lg-0 mb-4">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="about-us-card-icon shadow mb-lg-0 mb-3">
                                        <i className="fa-solid fa-wand-magic-sparkles fa-sm"></i>
                                    </div>
                                </div>
                                <div className="col-lg-9 ps-lg-0">
                                    <h5>{t('Güvenli ve Hızlı İşlem Altyapısı')}</h5>
                                    <p className="mb-0">
                                        {t('Paragon Yatırım, yatırımcılarının işlemlerini en güvenli ve hızlı şekilde gerçekleştirebilmeleri için ileri düzey teknoloji kullanır. Kapsamlı güvenlik önlemleriyle, tüm işlemlerinizin güvenliği garanti altındadır.')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="about-us-card shadow-sm mb-lg-0 mb-4">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="about-us-card-icon shadow mb-lg-0 mb-3">
                                        <i className="fa-solid fa-wand-magic-sparkles fa-sm"></i>
                                    </div>
                                </div>
                                <div className="col-lg-9 ps-lg-0">
                                    <h5>{t('Kapsamlı Eğitim ve Kaynaklar')}</h5>
                                    <p className="mb-0">
                                        {t('Yeni başlayanlardan deneyimli yatırımcılara kadar her seviyeye uygun eğitim materyalleri, seminerler ve rehberler sunuyoruz. Yatırımcılarımızın bilgi seviyesini artırarak, daha bilinçli kararlar almalarını sağlıyoruz.')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="about-us-card shadow-sm mb-lg-0 mb-4">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="about-us-card-icon shadow mb-lg-0 mb-3">
                                        <i className="fa-solid fa-wand-magic-sparkles fa-sm"></i>
                                    </div>
                                </div>
                                <div className="col-lg-9 ps-lg-0">
                                    <h5>{t('Profesyonel Analiz ve Strateji Desteği')}</h5>
                                    <p className="mb-0">
                                        {t('Piyasaları doğru analiz etmek, başarılı yatırımın anahtarıdır. Paragon, yatırımcılarına uzman ekibi tarafından sağlanan piyasa analizleri ve stratejik rehberlik ile her adımda destek sunar.')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="about-us-card shadow-sm">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="about-us-card-icon shadow mb-lg-0 mb-3">
                                        <i className="fa-solid fa-wand-magic-sparkles fa-sm"></i>
                                    </div>
                                </div>
                                <div className="col-lg-9 ps-lg-0">
                                    <h5>{t('Yüksek Başarı Oranı')}</h5>
                                    <p className="mb-0">
                                        {t('Paragon Yatırım, %85’e varan başarı oranıyla, yatırımcılarının kazanç sağlama potansiyelini en üst düzeye çıkarır. Yüksek likidite, düşük spread oranları ve stratejik platformlarımızla başarılı bir yatırım deneyimi sunuyoruz.')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUsCards